import { useEffect } from 'react';
import { useMatches } from '@tanstack/react-router';

const PageMeta = () => {
  const matches = useMatches();
  const nearestMatchWithMeta =
    matches.filter(({ staticData }) => !!staticData?.meta).at(-1) || {};
  const pageTitle = nearestMatchWithMeta.staticData?.meta?.title || 'Ledgible';

  useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  return null;
};

export default PageMeta;
